import React from 'react';
import logo from '../assets/Images/logo.svg';
const Navbar = () => {
  return (
    <nav>
      <img src={logo} alt="logo" className='logo'/>
    </nav>
  );
};

export default Navbar;
